import * as Yup from "yup";

interface FormValues {
  name: string;
  description: string;
}

export const schema = Yup.object().shape({
  name: Yup.string().required().min(5, "Por lo menos 5 caracteres"),
  description: Yup.string().required().min(5, "Por lo menos 5 caracteres"),
});

export const initialValues = (initialValues = {}): FormValues => {
  return {
    name: "",
    description: "",
    ...initialValues,
  };
};
